
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import 'rxjs/Rx';
import { GasContract } from '../models/gas-contract.model';
import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';

@Injectable()
export class GasContractService {
    private _authService: AuthService;

    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }

    getAll() {
        return this.http.get('api/GasContract', this.getAuthHeader(true));
    }

    getAllForDashboardLazyLoad(limit: number, offset: number, sortby: string, contractType: string, searchQuery: any = null) {
        return this.http.get(`api/GasContract/GetAllForDashboardLazyLoad/${limit}/${offset}${sortby !== "" ? "/" + sortby : "/ContractEndDate"}/${contractType}${searchQuery !== "" ? "/" + encodeURIComponent(searchQuery) : ""}`, this.getAuthHeader(true));
    }

    getFiltered(customerId: number) {
        return this.http.get('api/GasContract/GetFiltered/' + customerId, this.getAuthHeader(true));
    }

    getGasContractById(gcid: number) {
        return this.http.get('api/GasContract/GetGasContractById/' + gcid, this.getAuthHeader(true));
    }

    getGasContractByContractId(cid: number) {
        return this.http.get('api/GasContract/GetGasContractByContractId/' + cid, this.getAuthHeader(true));
    }

    getGasContractVMByContractId(cid: number) {
        return this.http.get('api/GasContract/GetGasContractViewModelByContractId/' + cid, this.getAuthHeader(true));
    }

    getAllByCustomer(customerId: number) {
        return this.http.get('api/GasContract/GetAllByCustomer/' + customerId, this.getAuthHeader(true));
    }

    getAllForDashboard() {
        return this.http.get('api/GasContract/GetAllForDashboard', this.getAuthHeader(true));
    }

    createUpdate(gasContract: GasContract) {
        return this.http.post('api/GasContract', gasContract, this.getAuthHeader(true));
    }

    delete(id: number) {
        return this.http.get('api/GasContract/Delete/' + id, this.getAuthHeader(true));
    }

    getEndexByDate(contractDate: string) {
        return this.http.get('api/GasContract/GetEndexByDate/' + contractDate, this.getAuthHeader(true));
    }

    downloadZip(facilityTypeId: number, contractId: number) {
        return this.http.get(`/api/ContractFile/DownloadZip/${facilityTypeId}/${contractId}`, {
            responseType: 'blob',
            headers: new HttpHeaders()
                .append('Authorization', 'Bearer ' + this.authService.accessToken)
                .append('Content-Type', 'application/json')
        });
    }

    downloadPdf(facilityTypeId: number, contractId: number, contractFileId: number) {
        return this.http.get(`/api/ContractFile/DownloadPdf/${facilityTypeId}/${contractId}/${contractFileId}`, {
            responseType: 'blob',
            headers: new HttpHeaders()
                .append('Authorization', 'Bearer ' + this.authService.accessToken)
                .append('Content-Type', 'application/json')
        });
    }

    exportExcel(ids: string) {
        return this.http.post(`/api/GasContract/ExportExcel`, { ids: ids }, {
            responseType: 'blob',
            headers: new HttpHeaders()
                .append('Authorization', 'Bearer ' + this.authService.accessToken)
                .append('Content-Type', 'application/json')
        });
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        var options = {
            headers: headers
        };

        return options;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/gas-contract.service.ts